import React, { useContext, useCallback } from "react";
import { useUser } from "@store/profile";
import { Context as AdminContext } from "./ui-builder/admin-context";
import { useAnonymousInterceptor } from "./with-anonymous";
import {
  useComments as useCommentsBase,
  useCommentCount as useCommentCountBase,
  CommentProvider as Provider,
  CommentContainer as Container,
} from "mibaby-frontend/social/comments";

// Just for convenience
export { useCommentsLoaded, getArgs } from "mibaby-frontend/social/comments";

/*
 * Reexport connected comment components
 */

// useComments
export const useComments = () => useCommentsBase(useUser());

// useCommentCount
export const useCommentCount = (args, load = true) => useCommentCountBase(args, load, useUser());

// CommentProvider
export const CommentProvider = props => <Provider user={useUser()} {...props} />;

// CommentContainer
export const CommentContainer = ({ autoload, lightboxId, lightboxArgs, ...props }) => {
  autoload = !useContext(AdminContext) && autoload;
  const user = useUser();
  const { config } = useCommentsBase(user);

  // Compose
  lightboxId = lightboxId || (config && config.register_lightbox_id) || undefined;
  const handleCompose = useCallback(
    useAnonymousInterceptor(fn => fn(), null, lightboxId, lightboxArgs)[0],
    [lightboxId, lightboxArgs]
  );

  return <Container autoload={autoload} user={user} onCompose={handleCompose} {...props} />;
};
